// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PageUserRead,
  PageUserReadFromJSON,
  PageUserReadToJSON,
} from "../models/PageUserRead";
import { type TenantRole, TenantRoleFromJSON, TenantRoleToJSON } from "../models/TenantRole";
import { type UserCreate, UserCreateFromJSON, UserCreateToJSON } from "../models/UserCreate";
import { type UserPut, UserPutFromJSON, UserPutToJSON } from "../models/UserPut";
import { type UserRead, UserReadFromJSON, UserReadToJSON } from "../models/UserRead";
import { type UserUpdate, UserUpdateFromJSON, UserUpdateToJSON } from "../models/UserUpdate";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface UserChangeImageRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
  /**
   *
   */
  imageUpload: Blob;
}

export interface UserCreateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  userCreate: UserCreate;
}

export interface UserDeleteRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
}

export interface UserListRequest {
  /**
   *
   */
  tenantId: string;
  /**
   * Page size limit
   */
  limit?: number;
  /**
   * Page offset
   */
  offset?: number;
  /**
   * Field to order by
   */
  orderBy?: UserListOrderByEnum;
  /**
   * Whether ordering is case-sensitive
   */
  orderByCaseSensitive?: boolean;
  /**
   * Filter on account state
   */
  active?: boolean | null;
  /**
   * Full text search on name and email
   */
  search?: string | null;
  /**
   * Roles to filter on
   */
  role?: Array<TenantRole> | null;
}

export interface UserPutRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
  /**
   *
   */
  userPut: UserPut;
}

export interface UserRemoveImageRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
}

export interface UserRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
}

export interface UserRetrieveImageRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
}

export interface UserUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  id: string;
  /**
   *
   */
  userUpdate: UserUpdate;
}

/**
 *
 */
export class UsersApi extends runtime.BaseAPI {
  /**
   * Creates request options for userChangeImage without sending the request
   */
  async userChangeImageRequestOpts(
    requestParameters: UserChangeImageRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userChangeImage().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling userChangeImage().'
      );
    }

    if (requestParameters["imageUpload"] == null) {
      throw new runtime.RequiredError(
        "imageUpload",
        'Required parameter "imageUpload" was null or undefined when calling userChangeImage().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }
    const consumes: runtime.Consume[] = [{ contentType: "multipart/form-data" }];
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes);

    let formParams: { append(param: string, value: any): any };
    let useForm = false;
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm;
    if (useForm) {
      formParams = new FormData();
    } else {
      formParams = new URLSearchParams();
    }

    if (requestParameters["imageUpload"] != null) {
      formParams.append("image_upload", requestParameters["imageUpload"] as any);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}/image`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: formParams,
    };
  }

  /**
   * Upload a user image.
   * Upload user image
   */
  async userChangeImageRaw(
    requestParameters: UserChangeImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.userChangeImageRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Upload a user image.
   * Upload user image
   */
  async userChangeImage(
    requestParameters: UserChangeImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.userChangeImageRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for userCreate without sending the request
   */
  async userCreateRequestOpts(requestParameters: UserCreateRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userCreate().'
      );
    }

    if (requestParameters["userCreate"] == null) {
      throw new runtime.RequiredError(
        "userCreate",
        'Required parameter "userCreate" was null or undefined when calling userCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: UserCreateToJSON(requestParameters["userCreate"]),
    };
  }

  /**
   * Add a user to the tenant.
   * Create a user
   */
  async userCreateRaw(
    requestParameters: UserCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UserRead>> {
    const requestOptions = await this.userCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserReadFromJSON(jsonValue));
  }

  /**
   * Add a user to the tenant.
   * Create a user
   */
  async userCreate(
    requestParameters: UserCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UserRead> {
    const response = await this.userCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for userDelete without sending the request
   */
  async userDeleteRequestOpts(requestParameters: UserDeleteRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userDelete().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling userDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Remove a user from this tenant.
   * Remove a user
   */
  async userDeleteRaw(
    requestParameters: UserDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.userDeleteRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove a user from this tenant.
   * Remove a user
   */
  async userDelete(
    requestParameters: UserDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.userDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for userList without sending the request
   */
  async userListRequestOpts(requestParameters: UserListRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userList().'
      );
    }

    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["active"] != null) {
      queryParameters["active"] = requestParameters["active"];
    }

    if (requestParameters["search"] != null) {
      queryParameters["search"] = requestParameters["search"];
    }

    if (requestParameters["role"] != null) {
      queryParameters["role"] = requestParameters["role"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "user_list",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * List users with their roles present in a tenant
   * List users in tenant
   */
  async userListRaw(
    requestParameters: UserListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageUserRead>> {
    const requestOptions = await this.userListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageUserReadFromJSON(jsonValue));
  }

  /**
   * List users with their roles present in a tenant
   * List users in tenant
   */
  async userList(
    requestParameters: UserListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageUserRead> {
    const response = await this.userListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for userPut without sending the request
   */
  async userPutRequestOpts(requestParameters: UserPutRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userPut().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling userPut().'
      );
    }

    if (requestParameters["userPut"] == null) {
      throw new runtime.RequiredError(
        "userPut",
        'Required parameter "userPut" was null or undefined when calling userPut().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: UserPutToJSON(requestParameters["userPut"]),
    };
  }

  /**
   * Notify the backend of a user login. If the user does not exist, a role may be assigned based on the identity provider and/or presence of an invitation.
   * user login in tenant
   */
  async userPutRaw(
    requestParameters: UserPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UserRead>> {
    const requestOptions = await this.userPutRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserReadFromJSON(jsonValue));
  }

  /**
   * Notify the backend of a user login. If the user does not exist, a role may be assigned based on the identity provider and/or presence of an invitation.
   * user login in tenant
   */
  async userPut(
    requestParameters: UserPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UserRead> {
    const response = await this.userPutRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for userRemoveImage without sending the request
   */
  async userRemoveImageRequestOpts(
    requestParameters: UserRemoveImageRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userRemoveImage().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling userRemoveImage().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}/image`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Remove a user image.
   * Remove user image
   */
  async userRemoveImageRaw(
    requestParameters: UserRemoveImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.userRemoveImageRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove a user image.
   * Remove user image
   */
  async userRemoveImage(
    requestParameters: UserRemoveImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.userRemoveImageRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for userRetrieve without sending the request
   */
  async userRetrieveRequestOpts(
    requestParameters: UserRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userRetrieve().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling userRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "user_list",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual Rana user.
   * show tenant user details
   */
  async userRetrieveRaw(
    requestParameters: UserRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UserRead>> {
    const requestOptions = await this.userRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserReadFromJSON(jsonValue));
  }

  /**
   * Return detailed information of an individual Rana user.
   * show tenant user details
   */
  async userRetrieve(
    requestParameters: UserRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UserRead> {
    const response = await this.userRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for userRetrieveImage without sending the request
   */
  async userRetrieveImageRequestOpts(
    requestParameters: UserRetrieveImageRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userRetrieveImage().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling userRetrieveImage().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}/image`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Get a user image.
   * Get user image
   */
  async userRetrieveImageRaw(
    requestParameters: UserRetrieveImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<runtime.HttpFile>> {
    const requestOptions = await this.userRetrieveImageRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.BlobApiResponse(response);
  }

  /**
   * Get a user image.
   * Get user image
   */
  async userRetrieveImage(
    requestParameters: UserRetrieveImageRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.HttpFile | null | undefined> {
    const response = await this.userRetrieveImageRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }

  /**
   * Creates request options for userUpdate without sending the request
   */
  async userUpdateRequestOpts(requestParameters: UserUpdateRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling userUpdate().'
      );
    }

    if (requestParameters["id"] == null) {
      throw new runtime.RequiredError(
        "id",
        'Required parameter "id" was null or undefined when calling userUpdate().'
      );
    }

    if (requestParameters["userUpdate"] == null) {
      throw new runtime.RequiredError(
        "userUpdate",
        'Required parameter "userUpdate" was null or undefined when calling userUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/users/{id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace("{id}", encodeURIComponent(String(requestParameters["id"])));

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: UserUpdateToJSON(requestParameters["userUpdate"]),
    };
  }

  /**
   * Change the role or (de)activate a Rana user.
   * Partially update a user
   */
  async userUpdateRaw(
    requestParameters: UserUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<UserRead>> {
    const requestOptions = await this.userUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => UserReadFromJSON(jsonValue));
  }

  /**
   * Change the role or (de)activate a Rana user.
   * Partially update a user
   */
  async userUpdate(
    requestParameters: UserUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<UserRead | null | undefined> {
    const response = await this.userUpdateRaw(requestParameters, initOverrides);
    switch (response.raw.status) {
      case 200:
        return await response.value();
      case 204:
        return null;
      default:
        return await response.value();
    }
  }
}

/**
 * @export
 */
export const UserListOrderByEnum = {
  GivenName: "given_name",
  GivenName2: "-given_name",
  FamilyName: "family_name",
  FamilyName2: "-family_name",
  Email: "email",
  Email2: "-email",
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
  UpdatedAt: "updated_at",
  UpdatedAt2: "-updated_at",
} as const;
export type UserListOrderByEnum = (typeof UserListOrderByEnum)[keyof typeof UserListOrderByEnum];
